module.exports = __webpack_public_path__ + "img/shop-ad-02.40f87f10.png";